/**
 * @generated SignedSource<<856ae584650d7d25ae9222cfa7d88827>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type redirectToPrerenderedCheckout_item$data = {
  readonly " $fragmentSpreads": FragmentRefs<"getCheckoutUrl_item">;
  readonly " $fragmentType": "redirectToPrerenderedCheckout_item";
};
export type redirectToPrerenderedCheckout_item$key = {
  readonly " $data"?: redirectToPrerenderedCheckout_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"redirectToPrerenderedCheckout_item">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "redirectToPrerenderedCheckout_item"
};

(node as any).hash = "5d951e72f43c3f25922a082d4b30e6f3";

export default node;
